module.exports = __webpack_public_path__ + "static/media/play-video.3af7e489.png";